import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const FotoVideographieHero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/425ddccedc3f0db19c859f46033997ec.jpg"
          alt="Foto Videographie Background"
          className="w-full h-full object-cover grayscale opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 relative z-10 pt-32 pb-20">
        <div className={`max-w-5xl mx-auto text-center transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <div className="mb-8">
            <span className="text-[#d1bc8a] text-sm uppercase tracking-[0.3em] font-light">
              Foto & Videographie
            </span>
          </div>
          
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold text-white mb-8 leading-none">
            Visuelle
            <br />
            <span className="text-[#d1bc8a]">Geschichten</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-white/80 mb-12 max-w-3xl mx-auto font-light leading-relaxed">
            Professionelle Foto- und Videoproduktion, die Emotionen weckt und Ihre Marke zum Leben erweckt
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button
              onClick={() => navigate('/kontakt')}
              className="px-8 py-4 bg-[#d1bc8a] text-black rounded-full hover:bg-[#c4af7d] transition-all duration-300 font-semibold text-lg whitespace-nowrap cursor-pointer"
            >
              Projekt starten
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default FotoVideographieHero;